const PORTAL_FIELD_KEYS = ['full_name', 'social_name', 'protocol_id', 'gender', 'birth_date'];

const DEFAULT_PORTAL_FIELDS = {
  full_name: { visible: true, mandatory: true },
  social_name: { visible: true, mandatory: false },
  protocol_id: { visible: true, mandatory: true },
  gender: { visible: true, mandatory: true },
  birth_date: { visible: true, mandatory: true, estimated_age: false },
};

export function isMandatory(field) {
  if (!field || !Array.isArray(field.mandatory) || field.mandatory.length === 0) {
    return false;
  }
  return Boolean(field.mandatory[field.mandatory.length - 1]);
}

function mapField(raw, defaults) {
  const source = raw && typeof raw === 'object' ? raw : {};
  const visible = source.visible !== false;
  const mandatory = Object.prototype.hasOwnProperty.call(source, 'mandatory')
    ? isMandatory(source)
    : defaults.mandatory;

  return { visible, mandatory };
}

export function getEditPatientDataFields(organization) {
  const cfg = organization?.patients_form_cfg;
  const rawFields = cfg?.form?.fields && typeof cfg.form.fields === 'object' ? cfg.form.fields : {};

  const result = {};

  PORTAL_FIELD_KEYS.forEach((key) => {
    const defaults = DEFAULT_PORTAL_FIELDS[key];
    result[key] = mapField(rawFields[key], defaults);
  });

  const birthRaw = rawFields.birth_date && typeof rawFields.birth_date === 'object' ? rawFields.birth_date : {};
  result.birth_date.estimated_age = Boolean(result.birth_date.visible && birthRaw.estimated_age === true);

  return result;
}
